import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { PaymentMethodAuthenticationModal } from '../../paymentMethodAuthenticationModal/PaymentMethodAuthenticationModal';
import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import LinkDebitCardForm from './LinkDebitCardForm';
import IwStripeProvider from '../../../../iwStripeProvider/IwStripeProvider';
import { getStripePublicKey } from '../../../../iwStripeProvider/StripeHelper';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = ({
    addPaymentMethodModal
}: {
    addPaymentMethodModal: RootState['addPaymentMethodModal'];
}) => addPaymentMethodModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const LinkDebitCard = ({
    requiresAuthentication,
    authenticationIframeURL,
    authenticationFailed,
    showTitle = true // Option used to remove title when used in an accordion
}: { showTitle?: boolean } & PropsFromRedux) => {
    if (requiresAuthentication) {
        return (
            <PaymentMethodAuthenticationModal
                authenticationIframeURL={authenticationIframeURL!}
            />
        );
    }

    return (
        // @ts-expect-error Not in TS yet
        <IwStripeProvider stripeKey={getStripePublicKey()}>
            <>
                {(showTitle || authenticationFailed) && (
                    <div className={styles.title}>
                        {showTitle && (
                            <FormattedMessage
                                {...messages.linkDebitCardTitle}
                            />
                        )}
                        {authenticationFailed && (
                            <div className={styles.linkDebitCardError}>
                                <FormattedMessage
                                    {...messages.linkDebitCardError}
                                />
                            </div>
                        )}
                    </div>
                )}
                <div className={styles.LinkDebitCard}>
                    <LinkDebitCardForm />
                </div>
            </>
        </IwStripeProvider>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LinkDebitCard);
